module.exports = __webpack_public_path__ + "static/media/AWS.a7e580cb.png";